// skeleton for MembershipList.tsx
export default function PricesSkeleton() {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[...Array(3)].map((_, index) => (
                <div key={index} className="bg-white rounded-lg shadow-lg p-8 flex flex-col justify-between border border-blue-200 animate-pulse">
                    <div>
                        <div className="h-8 bg-gray-300 rounded w-3/4 mb-4"></div>
                        <div className="h-5 bg-gray-300 rounded w-full mb-6"></div>
                        <div className="h-5 bg-gray-300 rounded w-5/6 mb-6"></div>
                        <div className="h-10 bg-gray-300 rounded w-1/2 mb-6"></div>
                        <ul className="space-y-3 mb-8">
                            {[...Array(4)].map((_, featureIndex) => (
                                <li key={featureIndex} className="flex items-center">
                                    <div className="w-5 h-5 bg-gray-300 rounded-full mr-2"></div>
                                    <div className="h-4 bg-gray-300 rounded w-3/4"></div>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="w-full h-12 bg-gray-300 rounded-lg"></div>
                </div>
            ))}
        </div>
    );
}
